import { render, staticRenderFns } from "./pamongJabatan.vue?vue&type=template&id=38752b5a&scoped=true&"
import script from "./pamongJabatan.vue?vue&type=script&lang=js&"
export * from "./pamongJabatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38752b5a",
  null
  
)

export default component.exports